import React, { useMemo, useState } from 'react';
import {
  AdminPageHeader,
  AdminTableWrap,
  AdminDevRowMeta,
  AdminDevTh,
  btnLink,
  btnPrimary,
  filtersRowClass,
  selectClass,
  tdClass,
} from '../adminUi';
import { useGrading } from './GradingContext';
import { GradingDeleteButton, GradingVisibilityBadge } from './GradingShared';
import { confirmAndRunDelete } from './utils';
import { deleteGradingDiffFactor } from '../../../../services/gradingService';

export default function GradingFactorsTab() {
  const { families, roleClusters, factors, questions, openDrawer, reload } = useGrading();
  const [familyFilter, setFamilyFilter] = useState('');

  const rows = useMemo(() => {
    return factors.map((f) => {
      const family = families.find((x) => x.id === f.family_id);
      const familyRoleClusters = roleClusters.filter((s) => s.family_id === f.family_id);
      const qCount = questions.filter((q) => q.diff_factor_id === f.id).length;
      const roleClusterCount = new Set(questions.filter((q) => q.diff_factor_id === f.id).map((q) => q.role_cluster_id)).size;
      return { f, family, familyRoleClusters, qCount, roleClusterCount };
    }).filter(({ f }) => !familyFilter || Number(f.family_id) === Number(familyFilter));
  }, [factors, families, roleClusters, questions, familyFilter]);

  return (
    <div>
      <AdminPageHeader
        title="Дифференцирующие факторы"
        subtitle="Единый набор факторов на Family; для каждой Role cluster может быть несколько вопросов на фактор"
        actions={
          <button type="button" className={btnPrimary} onClick={() => openDrawer({ type: 'factor', mode: 'create', familyId: families[0]?.id })}>
            Создать диффактор
          </button>
        }
      />

      <div className={filtersRowClass}>
        <select className={selectClass} value={familyFilter} onChange={(e) => setFamilyFilter(e.target.value)}>
          <option value="">Все Family</option>
          {families.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>

      <AdminTableWrap>
        <table className="w-full min-w-[800px] text-sm">
          <thead className="border-b border-slate-100 bg-slate-50/80">
            <tr>
              <AdminDevTh label="Название" dbField="diff_factors.name" />
              <AdminDevTh label="Family" dbField="diff_factors.family_id → families" />
              <AdminDevTh label="Вопросов" dbField="questions.diff_factor_id" />
              <AdminDevTh label="Role cluster покрыто" dbField="questions.role_cluster_id" />
              <AdminDevTh label="Видимость" dbField="diff_factors.is_visible" />
              <AdminDevTh label="Подсказка" dbField="diff_factors.question_hint" />
              <AdminDevTh label="Изменён" dbField="diff_factors.updated_at" />
              <AdminDevTh label="Действия" />
            </tr>
          </thead>
          <tbody>
            {rows.map(({ f, family, qCount, roleClusterCount }) => (
              <tr key={f.id} className="border-b border-slate-50 hover:bg-slate-50/50">
                <td className={tdClass}>
                  <div className="flex items-center gap-2 flex-wrap">
                    <button type="button" className={btnLink} onClick={() => openDrawer({ type: 'factor', mode: 'edit', id: f.id })}>
                      {f.name}
                    </button>
                    <GradingVisibilityBadge isVisible={f.is_visible} />
                  </div>
                  <AdminDevRowMeta parts={[`diff_factors.id=${f.id}`, `diff_factors.family_id=${f.family_id}`]} />
                  {f.description && <p className="text-xs text-slate-500 mt-0.5">{f.description}</p>}
                </td>
                <td className={tdClass}>{family?.name || '—'}</td>
                <td className={tdClass}>{qCount}</td>
                <td className={tdClass}>{roleClusterCount}</td>
                <td className={tdClass}>{f.is_visible === false ? 'Скрыто' : 'Видно'}</td>
                <td className={`${tdClass} max-w-xs truncate text-slate-600`}>{f.question_hint || '—'}</td>
                <td className={tdClass}>{new Date(f.updated_at).toLocaleDateString('ru-RU')}</td>
                <td className={tdClass}>
                  <div className="flex gap-3">
                    <button type="button" className={btnLink} onClick={() => openDrawer({ type: 'factor', mode: 'edit', id: f.id })}>Редактировать</button>
                    <GradingDeleteButton
                      onClick={() => confirmAndRunDelete(
                        f.name,
                        'Будут удалены все scoring-вопросы этого фактора.',
                        () => deleteGradingDiffFactor(f.id),
                        reload,
                      )}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </AdminTableWrap>
    </div>
  );
}
